module.exports = __webpack_public_path__ + "static/media/logo-mobile.13c8399e.svg";